import { fork } from 'redux-saga/effects';
import {
  getApplicationNotificationsFlow,
  readApplicationNotificationFlow,
  markNotificationSeenFlow,
  deleteApplicationNotificationFlow,
  getSolargrafSession,
  verifySolargrafSession,
  verifySolargrafEmail,
  requestSolargrafAccess,
  grantSolargrafAccess,
  getFleetDashBoardLinkFlow,
  systemOldViewCheck,
} from './containers/Layouts/saga';

import {
  createSystemFlow,
  getSiteDetailsFlow,
  getSiteSearchFlow,
} from './containers/CreateSystem/saga';

export default function* root() {
  yield fork(getApplicationNotificationsFlow);
  yield fork(readApplicationNotificationFlow);
  yield fork(markNotificationSeenFlow);
  yield fork(deleteApplicationNotificationFlow);
  yield fork(getSolargrafSession);
  yield fork(verifySolargrafSession);
  yield fork(verifySolargrafEmail);
  yield fork(requestSolargrafAccess);
  yield fork(grantSolargrafAccess);
  yield fork(getFleetDashBoardLinkFlow);
  yield fork(systemOldViewCheck);
  // system creation saga
  yield fork(createSystemFlow);
  yield fork(getSiteSearchFlow);
  yield fork(getSiteDetailsFlow);
}
